import { Fragment } from 'react';
import { Typography } from '@mui/material';
import { TrackedMention } from './mentionText.utils';

interface TextWithMentionsProps {
    message: string;
    mentions: TrackedMention[];
}

const MENTION_REGEX = /\[\[\[user~(\d+)\]\]\]/g;

export const TextWithMentions = (props: TextWithMentionsProps) => {
    const { message, mentions } = props;

    const messageParts = message.split(MENTION_REGEX).map((part, index) => {
        const userId = parseInt(part, 10);
        const mention = mentions.find((m) => m.id === userId);

        if (!Number.isNaN(userId) && mention) {
            return (
                <Typography
                    key={index}
                    component="span"
                    sx={{ color: mention.isSubscriber ? 'primary.main' : 'text.disabled' }}
                >{`@${mention.displayName}`}</Typography>
            );
        }

        return <Fragment key={index}>{part}</Fragment>;
    });

    return <>{messageParts}</>;
};
